import { useRef, useEffect } from 'react';
import { useQuery } from 'hooks/useCustomQuery';
import getCompanyPlatformUsers from '@/API/PlatformUser/getCompanyPlatformUsers';

const useGetCompanyPlatformUsers = (
    companyId,
    platformId,
    accountScope,
    setSummaryData,
    setPlatformUsers,
) => {
    const setSummaryDataRef = useRef(setSummaryData);
    setSummaryDataRef.current = setSummaryData;

    const setPlatformUsersRef = useRef(setPlatformUsers);
    setPlatformUsersRef.current = setPlatformUsers;

    const query = useQuery({
        queryKey: ['companyPlatformUsers', companyId, platformId],
        queryFn: () => {
            if (!companyId) {
                return Promise.reject(new Error('Invalid companyId'));
            }
            return getCompanyPlatformUsers(companyId, platformId, accountScope);
        },
        enabled: Boolean(companyId),
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        staleTime: 50,
    });

    useEffect(() => {
        if (!query.data) return;
        setSummaryDataRef.current(query.data);
        setPlatformUsersRef.current(query.data.platformUsers);
    }, [query.data]);

    return query;
};

export default useGetCompanyPlatformUsers;
